import axios from 'axios'

/**
 * Configuration file for axios
 * @type {AxiosInstance}
 */
const instance = axios.create({
  baseURL: process.env.AFRIPODS_API_URL,
})

instance.defaults.headers.common['Authorization'] = 'AUTH TOKEN FROM INSTANCE'

export default instance



// WEBPACK FOOTER //
// ./src/api/afripods-http/axios-config.js